// extracted by mini-css-extract-plugin
var _1 = "pZSrx";
export { _1 as "noLabelPadding" }
